module.exports = __webpack_public_path__ + "img/happytogether_option_03.048bf597.jpg";